import React, { useState, useEffect } from 'react'
import Footer from '../components/Footer'
import { purpose } from '../api/apiHandler'
import OuterHeader from '../components/OuterHeader'
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../store/slice/loaderSlice';
import Loader from '../components/Loader';
import Header from '../components/Header';


const Purpose = () => {
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.loader);
    const [data, setdata] = useState();
    useEffect(() => {
        dispatch(setLoading(true))
        purpose().then((response) => {
            dispatch(setLoading(false))
            setdata(response.data)
        }).catch((error) => {
            console.log(error);
        })
    }, [])


    return (
        <>
            {isLoading ?
                (<Loader loader_status={isLoading} />) :
                (
                    <main className="helprr-main">
                        {localStorage.getItem("token") ?
                            <OuterHeader /> :
                            <Header />
                        }
                        <section className="login-sec">
                            <div className="container">
                                <div className="row align-items-end">
                                    <div className="col-lg-8 col-xl-8 col-12">
                                        <p className="font_50 font_600">Our Purpose</p>
                                        <div dangerouslySetInnerHTML={{ __html: data && data.meta_value }} />
                                    </div>
                                    <div className="col-lg-4 col-xl-4 col-12">
                                        <div className="vector-img--1">
                                            <img src={process.env.PUBLIC_URL + "/assets/images/vector--1.svg"} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <Footer />
                    </main>
                )
            }
        </>
    )
}

export default Purpose